import request from "@/utils/request";

export default function agentSyncConfigGroup(id) {
  return request({
    url: `/device/device_group/agent/sync_t4/${id}`,
    method: "post",
  });
}
